export const validation = {
  lastName: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'minLength',
      expected: 1,
      message: 'Ce champ est obligatoire'
    }
  ],
  firstName: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'minLength',
      expected: 1,
      message: 'Ce champ est obligatoire'
    }
  ],
  email: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'email',
      message: 'Ce n\'est pas un email valide !'
    }
  ],
  address: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  zipcode: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'zipcode',
      message: 'Ce n\'est pas un code postal valide !'
    }
  ],
  city: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  surface: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'numeric',
      message: 'Uniquement des chiffres'
    }
  ],
  phone: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/inquiry/validation.js